import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import ProductSection from '../../models/ProductSection'

export interface ProductSectionListState extends PaginatedApiState {
  productSections?: ProductSection[] 
}

const ProductSectionList = (state: ProductSectionListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<ProductSectionListState>('PRODUCTSECTION_LIST')(state, action)
  }
}

export default ProductSectionList
